module.exports = __webpack_public_path__ + "img/40_63.a96637fa.png";